export default {
  productComment: {
    id: 'review_funnel_title_product_comment_title',
    defaultMessage: 'Tell us about your {model}',
  },
  details: {
    id: 'review_funnel_title_details_title',
    defaultMessage: 'Rate your {model} in detail',
  },
  attachments: {
    id: 'review_funnel_title_attachments_title',
    defaultMessage: 'Add a photo of your device',
  },
  summarySubtitle: {
    id: 'review_funnel_title_summary_subtitle',
    defaultMessage:
      'Your review is live. Thanks for taking the time to drop us a line.',
  },
} as const
